/* unplugin-vue-components disabled */import { render } from "./message_notification_detail.vue?vue&type=template&id=4c223ffe&scoped=true"
import script from "./message_notification_detail.vue?vue&type=script&lang=js"
export * from "./message_notification_detail.vue?vue&type=script&lang=js"

import "./message_notification_detail.vue?vue&type=style&index=0&id=4c223ffe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c223ffe"]])

export default __exports__